// ────────────────────────────────────────────────────────────────
// Day 10 — Chart Templates API (read-only metadata)
// Feeds the dynamic ChartDynamicEntryForm + summary renderer.
// ────────────────────────────────────────────────────────────────

import api from '@/lib/api';

export async function listTemplates() {
  const res = await api.get(`/participants/charts/templates`);
  return res.data?.data || [];
}

export async function getTemplate(code) {
  const res = await api.get(`/participants/charts/templates/${code}`);
  return res.data?.data;
}
